import {
  protoOf180f3jzyo7rfj as protoOf,
  Unit_instance104q5opgivhr8 as Unit_instance,
  Monotonic_instance19wu6xfdyzm85 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvsu7rzs9skj3fu as ValueTimeMark__elapsedNow_impl_eonqvs,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  toList383f556t1dixk as toList,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  emptyList1g2z5xcrvp2zy as emptyList,
  StringBuilder_init_$Create$2mwec1027v00x as StringBuilder_init_$Create$,
  _Char___init__impl__6a9atx281r2pd9o601g as _Char___init__impl__6a9atx,
  equals2au1ep9vhcato as equals,
  joinTo3lkanfaxbzac2 as joinTo,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  hashCodeq5arwsb9dgti as hashCode,
  Enum3alwj03lh1n41 as Enum,
  toString30pk9tzaqopn as toString,
  toString1pkumu07cwy4m as toString_0,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$32vb8wlewqrmh as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  Exception_init_$Init$2fx1sms2m4tu1 as Exception_init_$Init$_0,
  HashMap_init_$Create$1ria3pjlcm5i3 as HashMap_init_$Create$,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  LinkedHashSet_init_$Create$3qv13l7kzf0ni as LinkedHashSet_init_$Create$,
  LinkedHashMap_init_$Create$1p3p95clvi93w as LinkedHashMap_init_$Create$,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  addAll21mdhg523wnoa as addAll,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  asReversed308kw52j6ls1u as asReversed,
  ArrayDeque_init_$Create$1mbw636aazxd8 as ArrayDeque_init_$Create$,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  toList3jhuyej2anx2q as toList_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getKClass1s3j9wy1cofik as getKClass,
  copyToArray2j022khrow2yi as copyToArray,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  TimedValuew9j01dao9jci as TimedValue,
  ArrayDeque_init_$Create$h67uqnktr40s as ArrayDeque_init_$Create$_0,
  _Duration___get_inWholeMicroseconds__impl__8oe8vvba5uudv5aao5 as _Duration___get_inWholeMicroseconds__impl__8oe8vv,
  plus1di085adi7f7m as plus,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Companion_getInstance3tnw2k4njrdpv as Companion_getInstance,
  Exception_init_$Create$2bsr4ndahzetu as Exception_init_$Create$,
  split2bvyvnrlcifjv as split,
  LazyThreadSafetyMode_NONE_getInstance31hcehq5w8bn3 as LazyThreadSafetyMode_NONE_getInstance,
} from './kotlin-kotlin-stdlib.mjs';
import { ThreadLocalRef2gwn4e0n07y5w as ThreadLocalRef } from './Stately-stately-concurrency.mjs';
import {
  ConcurrentMutableMap_init_$Create$4dg5nsu16v6w as ConcurrentMutableMap_init_$Create$,
  ConcurrentMutableSet_init_$Create$18hqiopn1culi as ConcurrentMutableSet_init_$Create$,
} from './Stately-stately-concurrent-collections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(Koin, 'Koin', Koin);
initMetadataForCompanion(Companion);
initMetadataForClass(KoinApplication, 'KoinApplication');
function getKoin() {
  return KoinPlatformTools_instance.f1a().n18();
}
initMetadataForInterface(KoinComponent, 'KoinComponent');
initMetadataForInterface(KoinScopeComponent, 'KoinScopeComponent', VOID, VOID, [KoinComponent]);
initMetadataForClass(BeanDefinition, 'BeanDefinition');
initMetadataForClass(Kind, 'Kind', VOID, Enum);
initMetadataForClass(Callbacks, 'Callbacks', Callbacks);
initMetadataForClass(KoinDefinition, 'KoinDefinition');
initMetadataForClass(ClosedScopeException, 'ClosedScopeException', VOID, Exception);
initMetadataForClass(DefinitionOverrideException, 'DefinitionOverrideException', VOID, Exception);
initMetadataForClass(InstanceCreationException, 'InstanceCreationException', VOID, Exception);
initMetadataForClass(KoinApplicationAlreadyStartedException, 'KoinApplicationAlreadyStartedException', VOID, Exception);
initMetadataForClass(NoDefinitionFoundException, 'NoDefinitionFoundException', VOID, Exception);
initMetadataForClass(ExtensionManager, 'ExtensionManager');
initMetadataForClass(InstanceFactory, 'InstanceFactory');
initMetadataForClass(FactoryInstanceFactory, 'FactoryInstanceFactory', VOID, InstanceFactory);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ResolutionContext, 'ResolutionContext');
initMetadataForClass(NoClass, 'NoClass', NoClass);
initMetadataForClass(ScopedInstanceFactory, 'ScopedInstanceFactory', VOID, InstanceFactory);
initMetadataForClass(SingleInstanceFactory, 'SingleInstanceFactory', VOID, InstanceFactory);
initMetadataForClass(Logger, 'Logger');
initMetadataForClass(EmptyLogger, 'EmptyLogger', EmptyLogger, Logger);
initMetadataForClass(Level, 'Level', VOID, Enum);
initMetadataForClass(Module, 'Module', Module);
initMetadataForClass(ParametersHolder, 'ParametersHolder', ParametersHolder);
initMetadataForClass(StringQualifier, 'StringQualifier');
initMetadataForClass(TypeQualifier, 'TypeQualifier');
initMetadataForClass(InstanceRegistry, 'InstanceRegistry');
initMetadataForClass(OptionRegistry, 'OptionRegistry', OptionRegistry);
initMetadataForClass(PropertyRegistry, 'PropertyRegistry');
initMetadataForCompanion(Companion_1);
initMetadataForClass(ScopeRegistry, 'ScopeRegistry');
initMetadataForClass(CoreResolver, 'CoreResolver');
initMetadataForClass(Scope, 'Scope');
initMetadataForObject(GlobalContext, 'GlobalContext');
initMetadataForObject(KoinPlatformTools, 'KoinPlatformTools');
//endregion
function Koin() {
  this.x18_1 = new EmptyLogger();
  this.y18_1 = new CoreResolver(this);
  this.z18_1 = new ScopeRegistry(this);
  this.a19_1 = new InstanceRegistry(this);
  this.b19_1 = new PropertyRegistry(this);
  this.c19_1 = new ExtensionManager(this);
  this.d19_1 = new OptionRegistry();
}
protoOf(Koin).a4 = function () {
  this.z18_1.i19();
  this.a19_1.i19();
  this.b19_1.a4();
  this.c19_1.a4();
};
protoOf(Koin).q19 = function (modules, allowOverride, createEagerInstances) {
  var flattedModules = flatten(modules);
  this.a19_1.r19(flattedModules, allowOverride);
  this.z18_1.s19(flattedModules);
  if (createEagerInstances) {
    this.t19();
  }
};
protoOf(Koin).t19 = function () {
  this.x18_1.v19('Create eager instances ...');
  // Inline function 'kotlin.time.measureTime' call
  // Inline function 'kotlin.time.measureTime' call
  var mark = Monotonic_instance.fd();
  this.a19_1.w19();
  var duration = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  this.x18_1.v19('Created eager instances in ' + get_inMs(duration) + ' ms');
};
function loadModules($this, modules) {
  $this.x19_1.q19(modules, $this.y19_1, false);
}
function Companion() {
}
protoOf(Companion).z19 = function () {
  var app = new KoinApplication();
  return app;
};
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function KoinApplication() {
  this.x19_1 = new Koin();
  this.y19_1 = true;
}
protoOf(KoinApplication).a1a = function (modules) {
  return this.b1a(toList(modules));
};
protoOf(KoinApplication).b1a = function (modules) {
  var tmp0 = this.x19_1.x18_1;
  // Inline function 'org.koin.core.logger.Logger.isAt' call
  var lvl = Level_INFO_getInstance();
  if (tmp0.u19_1.m2(lvl) <= 0) {
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.time.measureTime' call
    var mark = Monotonic_instance.fd();
    loadModules(this, modules);
    var duration = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    var count = this.x19_1.a19_1.c1a();
    this.x19_1.x18_1.d1a(Level_INFO_getInstance(), 'Started ' + count + ' definitions in ' + get_inMs(duration) + ' ms');
  } else {
    loadModules(this, modules);
  }
  return this;
};
function KoinComponent() {
}
function KoinScopeComponent() {
}
function startKoin(appDeclaration) {
  return KoinPlatformTools_instance.f1a().h1a(appDeclaration);
}
function stopKoin() {
  return KoinPlatformTools_instance.f1a().i1a();
}
function BeanDefinition$toString$lambda(it) {
  return getFullName(it);
}
function BeanDefinition(scopeQualifier, primaryType, qualifier, definition, kind, secondaryTypes) {
  qualifier = qualifier === VOID ? null : qualifier;
  secondaryTypes = secondaryTypes === VOID ? emptyList() : secondaryTypes;
  this.j1a_1 = scopeQualifier;
  this.k1a_1 = primaryType;
  this.l1a_1 = qualifier;
  this.m1a_1 = definition;
  this.n1a_1 = kind;
  this.o1a_1 = secondaryTypes;
  this.p1a_1 = new Callbacks();
  this.q1a_1 = false;
}
protoOf(BeanDefinition).toString = function () {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.c8(_Char___init__impl__6a9atx(91));
  this_0.a8(this.n1a_1);
  this_0.b8(": '");
  this_0.b8(getFullName(this.k1a_1));
  this_0.c8(_Char___init__impl__6a9atx(39));
  if (!(this.l1a_1 == null)) {
    this_0.b8(',qualifier:');
    this_0.a8(this.l1a_1);
  }
  if (!equals(this.j1a_1, Companion_getInstance_2().s1a_1)) {
    this_0.b8(',scope:');
    this_0.a8(this.j1a_1);
  }
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!this.o1a_1.p()) {
    this_0.b8(',binds:');
    var tmp = this.o1a_1;
    joinTo(tmp, this_0, ',', VOID, VOID, VOID, VOID, BeanDefinition$toString$lambda);
  }
  this_0.c8(_Char___init__impl__6a9atx(93));
  return this_0.toString();
};
protoOf(BeanDefinition).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BeanDefinition))
    THROW_CCE();
  if (!this.k1a_1.equals(other.k1a_1))
    return false;
  if (!equals(this.l1a_1, other.l1a_1))
    return false;
  if (!equals(this.j1a_1, other.j1a_1))
    return false;
  return true;
};
protoOf(BeanDefinition).hashCode = function () {
  var tmp0_safe_receiver = this.l1a_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  result = imul(31, result) + this.k1a_1.hashCode() | 0;
  result = imul(31, result) + hashCode(this.j1a_1) | 0;
  return result;
};
var Kind_Singleton_instance;
var Kind_Factory_instance;
var Kind_Scoped_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_Singleton_instance = new Kind('Singleton', 0);
  Kind_Factory_instance = new Kind('Factory', 1);
  Kind_Scoped_instance = new Kind('Scoped', 2);
}
function Kind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Kind_Singleton_getInstance() {
  Kind_initEntries();
  return Kind_Singleton_instance;
}
function Kind_Factory_getInstance() {
  Kind_initEntries();
  return Kind_Factory_instance;
}
function Callbacks(onClose) {
  onClose = onClose === VOID ? null : onClose;
  this.t1a_1 = onClose;
}
protoOf(Callbacks).toString = function () {
  return 'Callbacks(onClose=' + toString(this.t1a_1) + ')';
};
protoOf(Callbacks).hashCode = function () {
  return this.t1a_1 == null ? 0 : hashCode(this.t1a_1);
};
protoOf(Callbacks).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Callbacks))
    return false;
  var tmp0_other_with_cast = other instanceof Callbacks ? other : THROW_CCE();
  if (!equals(this.t1a_1, tmp0_other_with_cast.t1a_1))
    return false;
  return true;
};
function KoinDefinition(module_0, factory) {
  this.u1a_1 = module_0;
  this.v1a_1 = factory;
}
protoOf(KoinDefinition).toString = function () {
  return 'KoinDefinition(module=' + toString_0(this.u1a_1) + ', factory=' + toString_0(this.v1a_1) + ')';
};
protoOf(KoinDefinition).hashCode = function () {
  var result = this.u1a_1.hashCode();
  result = imul(result, 31) + hashCode(this.v1a_1) | 0;
  return result;
};
protoOf(KoinDefinition).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof KoinDefinition))
    return false;
  var tmp0_other_with_cast = other instanceof KoinDefinition ? other : THROW_CCE();
  if (!this.u1a_1.equals(tmp0_other_with_cast.u1a_1))
    return false;
  if (!equals(this.v1a_1, tmp0_other_with_cast.v1a_1))
    return false;
  return true;
};
function ClosedScopeException(msg) {
  Exception_init_$Init$(msg, this);
  captureStack(this, ClosedScopeException);
}
function DefinitionOverrideException(msg) {
  Exception_init_$Init$(msg, this);
  captureStack(this, DefinitionOverrideException);
}
function InstanceCreationException(msg, parent) {
  Exception_init_$Init$_0(msg, parent, this);
  captureStack(this, InstanceCreationException);
}
function KoinApplicationAlreadyStartedException(msg) {
  Exception_init_$Init$(msg, this);
  captureStack(this, KoinApplicationAlreadyStartedException);
}
function NoDefinitionFoundException(msg) {
  Exception_init_$Init$(msg, this);
  captureStack(this, NoDefinitionFoundException);
}
function ExtensionManager(_koin) {
  this.o19_1 = _koin;
  var tmp = this;
  // Inline function 'kotlin.collections.hashMapOf' call
  tmp.p19_1 = HashMap_init_$Create$();
}
protoOf(ExtensionManager).a4 = function () {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = this.p19_1.c2().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    element.w1a();
  }
};
function FactoryInstanceFactory(beanDefinition) {
  InstanceFactory.call(this, beanDefinition);
}
protoOf(FactoryInstanceFactory).y1a = function (scope) {
  var tmp0_safe_receiver = this.z1a_1.p1a_1.t1a_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver(null);
};
protoOf(FactoryInstanceFactory).b1b = function () {
};
protoOf(FactoryInstanceFactory).c1b = function (context) {
  return this.d1b(context);
};
function Companion_0() {
  this.e1b_1 = '\n\t';
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function InstanceFactory(beanDefinition) {
  this.z1a_1 = beanDefinition;
}
protoOf(InstanceFactory).d1b = function (context) {
  context.f1b_1.v19("| (+) '" + this.z1a_1.toString() + "'");
  try {
    var tmp0_elvis_lhs = context.j1b_1;
    var parameters = tmp0_elvis_lhs == null ? emptyParametersHolder() : tmp0_elvis_lhs;
    return this.z1a_1.m1a_1(context.g1b_1, parameters);
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      var stack = KoinPlatformTools_instance.m1b(e);
      context.f1b_1.n1b("* Instance creation error : could not create instance for '" + this.z1a_1.toString() + "': " + stack);
      throw new InstanceCreationException("Could not create instance for '" + this.z1a_1.toString() + "'", e);
    } else {
      throw $p;
    }
  }
};
protoOf(InstanceFactory).a1b = function (scope, $super) {
  scope = scope === VOID ? null : scope;
  var tmp;
  if ($super === VOID) {
    this.y1a(scope);
    tmp = Unit_instance;
  } else {
    tmp = $super.y1a.call(this, scope);
  }
  return tmp;
};
function ResolutionContext(logger, scope, clazz, qualifier, parameters) {
  qualifier = qualifier === VOID ? null : qualifier;
  parameters = parameters === VOID ? null : parameters;
  this.f1b_1 = logger;
  this.g1b_1 = scope;
  this.h1b_1 = clazz;
  this.i1b_1 = qualifier;
  this.j1b_1 = parameters;
  this.k1b_1 = "t:'" + getFullName(this.h1b_1) + "' - q:'" + toString(this.i1b_1) + "'";
  this.l1b_1 = null;
}
protoOf(ResolutionContext).o1b = function (s) {
  var rc = new ResolutionContext(this.f1b_1, s, this.h1b_1, this.i1b_1, this.j1b_1);
  rc.l1b_1 = s.s1b_1;
  return rc;
};
function NoClass() {
}
function ScopedInstanceFactory() {
}
protoOf(ScopedInstanceFactory).y1a = function (scope) {
  if (scope == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = this.z1a_1.p1a_1.t1a_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(this.a1c_1.a2(scope.q1b_1));
    this.a1c_1.i2(scope.q1b_1);
  }
};
function getValue($this) {
  var tmp0_elvis_lhs = $this.c1c_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = "Single instance created couldn't return value";
    throw IllegalStateException_init_$Create$(toString_0(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SingleInstanceFactory$get$lambda(this$0, $context) {
  return function () {
    var tmp;
    if (!this$0.d1c($context)) {
      this$0.c1c_1 = this$0.d1b($context);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SingleInstanceFactory(beanDefinition) {
  InstanceFactory.call(this, beanDefinition);
  this.c1c_1 = null;
}
protoOf(SingleInstanceFactory).d1c = function (context) {
  return !(this.c1c_1 == null);
};
protoOf(SingleInstanceFactory).y1a = function (scope) {
  var tmp0_safe_receiver = this.z1a_1.p1a_1.t1a_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver(this.c1c_1);
  this.c1c_1 = null;
};
protoOf(SingleInstanceFactory).b1b = function () {
  this.a1b();
};
protoOf(SingleInstanceFactory).d1b = function (context) {
  var tmp;
  if (this.c1c_1 == null) {
    tmp = protoOf(InstanceFactory).d1b.call(this, context);
  } else {
    tmp = getValue(this);
  }
  return tmp;
};
protoOf(SingleInstanceFactory).c1b = function (context) {
  var tmp = KoinPlatformTools_instance;
  tmp.e1c(this, SingleInstanceFactory$get$lambda(this, context));
  return getValue(this);
};
function EmptyLogger() {
  Logger.call(this, Level_NONE_getInstance());
}
protoOf(EmptyLogger).d1a = function (level, msg) {
};
function Logger(level) {
  level = level === VOID ? Level_INFO_getInstance() : level;
  this.u19_1 = level;
}
protoOf(Logger).v19 = function (msg) {
  this.h1c(Level_DEBUG_getInstance(), msg);
};
protoOf(Logger).g1c = function (msg) {
  this.h1c(Level_WARNING_getInstance(), msg);
};
protoOf(Logger).n1b = function (msg) {
  this.h1c(Level_ERROR_getInstance(), msg);
};
protoOf(Logger).h1c = function (lvl, msg) {
  // Inline function 'org.koin.core.logger.Logger.isAt' call
  if (this.u19_1.m2(lvl) <= 0) {
    this.d1a(lvl, msg);
  }
};
var Level_DEBUG_instance;
var Level_INFO_instance;
var Level_WARNING_instance;
var Level_ERROR_instance;
var Level_NONE_instance;
var Level_entriesInitialized;
function Level_initEntries() {
  if (Level_entriesInitialized)
    return Unit_instance;
  Level_entriesInitialized = true;
  Level_DEBUG_instance = new Level('DEBUG', 0);
  Level_INFO_instance = new Level('INFO', 1);
  Level_WARNING_instance = new Level('WARNING', 2);
  Level_ERROR_instance = new Level('ERROR', 3);
  Level_NONE_instance = new Level('NONE', 4);
}
function Level(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Level_DEBUG_getInstance() {
  Level_initEntries();
  return Level_DEBUG_instance;
}
function Level_INFO_getInstance() {
  Level_initEntries();
  return Level_INFO_instance;
}
function Level_WARNING_getInstance() {
  Level_initEntries();
  return Level_WARNING_instance;
}
function Level_ERROR_getInstance() {
  Level_initEntries();
  return Level_ERROR_instance;
}
function Level_NONE_getInstance() {
  Level_initEntries();
  return Level_NONE_instance;
}
function Module(_createdAtStart) {
  _createdAtStart = _createdAtStart === VOID ? false : _createdAtStart;
  this.i1c_1 = _createdAtStart;
  this.j1c_1 = generateId(KoinPlatformTools_instance);
  this.k1c_1 = LinkedHashSet_init_$Create$();
  this.l1c_1 = LinkedHashMap_init_$Create$();
  this.m1c_1 = LinkedHashSet_init_$Create$();
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.n1c_1 = ArrayList_init_$Create$();
}
protoOf(Module).o1c = function (module_0) {
  addAll(this.n1c_1, module_0);
};
protoOf(Module).p1c = function (instanceFactory) {
  var def = instanceFactory.z1a_1;
  var tmp0 = def.k1a_1;
  var tmp1 = def.l1a_1;
  // Inline function 'org.koin.core.definition.indexKey' call
  var scopeQualifier = def.j1a_1;
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.b8(getFullName(tmp0));
  this_0.c8(_Char___init__impl__6a9atx(58));
  var tmp1_elvis_lhs = tmp1 == null ? null : tmp1.t();
  this_0.b8(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
  this_0.c8(_Char___init__impl__6a9atx(58));
  this_0.a8(scopeQualifier);
  var mapping = this_0.toString();
  this.q1c(mapping, instanceFactory);
};
protoOf(Module).r1c = function (instanceFactory) {
  this.k1c_1.e(instanceFactory);
};
protoOf(Module).q1c = function (mapping, factory) {
  // Inline function 'kotlin.collections.set' call
  this.l1c_1.h2(mapping, factory);
};
protoOf(Module).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Module))
    return false;
  return this.j1c_1 === other.j1c_1;
};
protoOf(Module).hashCode = function () {
  return getStringHashCode(this.j1c_1);
};
function flatten(modules) {
  // Inline function 'kotlin.collections.linkedSetOf' call
  var flatten = LinkedHashSet_init_$Create$();
  var stack = ArrayDeque_init_$Create$(asReversed(modules));
  $l$loop_0: while (true) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!!stack.p()) {
      break $l$loop_0;
    }
    var current = stack.re();
    if (!flatten.e(current)) {
      continue $l$loop_0;
    }
    var _iterator__ex2g4s = current.n1c_1.j();
    while (_iterator__ex2g4s.k()) {
      var module_0 = _iterator__ex2g4s.l();
      if (!flatten.u1(module_0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        stack.e(module_0);
      }
    }
  }
  return flatten;
}
function overrideError(factory, mapping) {
  throw new DefinitionOverrideException('Already existing definition for ' + factory.z1a_1.toString() + ' at ' + mapping);
}
function getFirstValue($this, clazz) {
  var tmp0 = $this.s1c_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (clazz.qa(element)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp = tmp$ret$1;
  return (tmp == null ? true : !(tmp == null)) ? tmp : null;
}
function getIndexedValue($this, clazz) {
  // Inline function 'kotlin.takeIf' call
  var this_0 = $this.s1c_1.o($this.u1c_1);
  var tmp;
  if (clazz.qa(this_0)) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp_0 = tmp;
  var currentValue = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : null;
  if (!(currentValue == null)) {
    $this.v1c();
  }
  return currentValue;
}
function ParametersHolder(_values, useIndexedValues) {
  var tmp;
  if (_values === VOID) {
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp = ArrayList_init_$Create$();
  } else {
    tmp = _values;
  }
  _values = tmp;
  useIndexedValues = useIndexedValues === VOID ? null : useIndexedValues;
  this.s1c_1 = _values;
  this.t1c_1 = useIndexedValues;
  this.u1c_1 = 0;
}
protoOf(ParametersHolder).c2 = function () {
  return this.s1c_1;
};
protoOf(ParametersHolder).p = function () {
  return this.s1c_1.p();
};
protoOf(ParametersHolder).w1c = function (clazz) {
  var tmp;
  if (this.s1c_1.p()) {
    tmp = null;
  } else {
    var tmp_0;
    switch (this.t1c_1) {
      case null:
        var tmp1_elvis_lhs = getIndexedValue(this, clazz);
        tmp_0 = tmp1_elvis_lhs == null ? getFirstValue(this, clazz) : tmp1_elvis_lhs;
        break;
      case true:
        tmp_0 = getIndexedValue(this, clazz);
        break;
      default:
        tmp_0 = getFirstValue(this, clazz);
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(ParametersHolder).v1c = function () {
  if (this.u1c_1 < get_lastIndex(this.s1c_1)) {
    this.u1c_1 = this.u1c_1 + 1 | 0;
  }
};
protoOf(ParametersHolder).toString = function () {
  return 'DefinitionParameters' + toString_0(toList_0(this.s1c_1));
};
protoOf(ParametersHolder).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ParametersHolder))
    return false;
  return equals(this.c2(), other.c2()) && this.t1c_1 == other.t1c_1;
};
protoOf(ParametersHolder).hashCode = function () {
  var tmp = imul(31, hashCode(this.c2()));
  var tmp0_safe_receiver = this.t1c_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getBooleanHashCode(tmp0_safe_receiver);
  return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
};
function emptyParametersHolder() {
  return new ParametersHolder();
}
function _q(name) {
  return new StringQualifier(name);
}
function named(name) {
  return new StringQualifier(name);
}
function StringQualifier(value) {
  this.x1c_1 = value;
}
protoOf(StringQualifier).t = function () {
  return this.x1c_1;
};
protoOf(StringQualifier).toString = function () {
  return this.x1c_1;
};
protoOf(StringQualifier).hashCode = function () {
  return getStringHashCode(this.x1c_1);
};
protoOf(StringQualifier).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StringQualifier))
    return false;
  var tmp0_other_with_cast = other instanceof StringQualifier ? other : THROW_CCE();
  if (!(this.x1c_1 === tmp0_other_with_cast.x1c_1))
    return false;
  return true;
};
function TypeQualifier(type) {
  this.y1c_1 = type;
  this.z1c_1 = getFullName(this.y1c_1);
}
protoOf(TypeQualifier).t = function () {
  return this.z1c_1;
};
protoOf(TypeQualifier).toString = function () {
  return this.z1c_1;
};
protoOf(TypeQualifier).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof TypeQualifier))
    THROW_CCE();
  if (!(this.z1c_1 === other.z1c_1))
    return false;
  return true;
};
protoOf(TypeQualifier).hashCode = function () {
  return getStringHashCode(this.z1c_1);
};
function addAllEagerInstances($this, module_0) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = module_0.k1c_1.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0 = $this.l19_1;
    // Inline function 'kotlin.collections.set' call
    var key = element.z1a_1.hashCode();
    tmp0.h2(key, element);
  }
}
function loadModule($this, module_0, allowOverride) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = module_0.l1c_1.r().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var mapping = element.s();
    // Inline function 'kotlin.collections.component2' call
    var factory = element.t();
    $this.a1d(allowOverride, mapping, factory);
  }
}
function createEagerInstances($this, instances) {
  var defaultContext = new ResolutionContext($this.j19_1.x18_1, $this.j19_1.z18_1.h19_1, getKClass(NoClass));
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = instances.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    element.c1b(defaultContext);
  }
}
function InstanceRegistry(_koin) {
  this.j19_1 = _koin;
  this.k19_1 = KoinPlatformTools_instance.b1d();
  this.l19_1 = KoinPlatformTools_instance.b1d();
}
protoOf(InstanceRegistry).r19 = function (modules, allowOverride) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = modules.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    loadModule(this, element, allowOverride);
    addAllEagerInstances(this, element);
  }
};
protoOf(InstanceRegistry).w19 = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.l19_1.c2();
  var tmp$ret$0 = copyToArray(this_0);
  var instances = arrayListOf(tmp$ret$0.slice());
  this.l19_1.d2();
  createEagerInstances(this, instances);
};
protoOf(InstanceRegistry).c1d = function (allowOverride, mapping, factory, logWarning) {
  if (this.k19_1.a2(mapping) == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    if (!allowOverride) {
      overrideError(factory, mapping);
    } else if (logWarning) {
      this.j19_1.x18_1.g1c("(+) override index '" + mapping + "' -> '" + factory.z1a_1.toString() + "'");
      var tmp0 = this.l19_1.c2();
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.j();
        while (_iterator__ex2g4s.k()) {
          var element = _iterator__ex2g4s.l();
          if (element.z1a_1.equals(factory.z1a_1)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var existingFactory = tmp$ret$1;
      if (!(existingFactory == null)) {
        this.l19_1.i2(factory.z1a_1.hashCode());
      }
    }
  }
  this.j19_1.x18_1.v19("(+) index '" + mapping + "' -> '" + factory.z1a_1.toString() + "'");
  // Inline function 'kotlin.collections.set' call
  this.k19_1.h2(mapping, factory);
};
protoOf(InstanceRegistry).a1d = function (allowOverride, mapping, factory, logWarning, $super) {
  logWarning = logWarning === VOID ? true : logWarning;
  var tmp;
  if ($super === VOID) {
    this.c1d(allowOverride, mapping, factory, logWarning);
    tmp = Unit_instance;
  } else {
    tmp = $super.c1d.call(this, allowOverride, mapping, factory, logWarning);
  }
  return tmp;
};
protoOf(InstanceRegistry).d1d = function (clazz, qualifier, scopeQualifier) {
  // Inline function 'org.koin.core.definition.indexKey' call
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.b8(getFullName(clazz));
  this_0.c8(_Char___init__impl__6a9atx(58));
  var tmp1_elvis_lhs = qualifier == null ? null : qualifier.t();
  this_0.b8(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
  this_0.c8(_Char___init__impl__6a9atx(58));
  this_0.a8(scopeQualifier);
  var indexKey = this_0.toString();
  return this.k19_1.a2(indexKey);
};
protoOf(InstanceRegistry).e1d = function (qualifier, klass, context) {
  var tmp0_safe_receiver = context.g1b_1.s1b_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    context.l1b_1 = tmp0_safe_receiver;
    tmp = this.f1d(qualifier, klass, tmp0_safe_receiver, context);
  }
  return tmp;
};
protoOf(InstanceRegistry).f1d = function (qualifier, clazz, scopeQualifier, instanceContext) {
  var tmp0_safe_receiver = this.d1d(clazz, qualifier, scopeQualifier);
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c1b(instanceContext);
  return (tmp == null ? true : !(tmp == null)) ? tmp : null;
};
protoOf(InstanceRegistry).g1d = function (scope) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.k19_1.c2();
  var factories = copyToArray(this_0);
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = factories.length;
  while (inductionVariable < last) {
    var element = factories[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (element instanceof ScopedInstanceFactory) {
      destination.e(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = destination.j();
  while (_iterator__ex2g4s.k()) {
    var element_0 = _iterator__ex2g4s.l();
    element_0.y1a(scope);
  }
};
protoOf(InstanceRegistry).i19 = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.k19_1.c2();
  var factories = copyToArray(this_0);
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = factories.length;
  while (inductionVariable < last) {
    var element = factories[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    element.b1b();
  }
  this.k19_1.d2();
};
protoOf(InstanceRegistry).c1a = function () {
  return this.k19_1.m();
};
function OptionRegistry() {
  var tmp = this;
  // Inline function 'kotlin.collections.hashMapOf' call
  tmp.h1d_1 = HashMap_init_$Create$();
}
function PropertyRegistry(_koin) {
  this.m19_1 = _koin;
  this.n19_1 = KoinPlatformTools_instance.b1d();
}
protoOf(PropertyRegistry).a4 = function () {
  this.n19_1.d2();
};
function closeAllScopes($this) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = $this.g19_1.c2();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = copyToArray(this_0);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    element.a4();
  }
}
function loadModule_0($this, module_0) {
  $this.f19_1.n(module_0.m1c_1);
}
function Companion_1() {
  Companion_instance_1 = this;
  this.r1a_1 = '_root_';
  this.s1a_1 = _q('_root_');
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 == null)
    new Companion_1();
  return Companion_instance_1;
}
function ScopeRegistry(_koin) {
  Companion_getInstance_2();
  this.e19_1 = _koin;
  this.f19_1 = KoinPlatformTools_instance.i1d();
  this.g19_1 = KoinPlatformTools_instance.b1d();
  this.h19_1 = new Scope(Companion_getInstance_2().s1a_1, '_root_', true, VOID, this.e19_1);
  this.f19_1.e(this.h19_1.p1b_1);
  var tmp0 = this.g19_1;
  var tmp1 = this.h19_1.q1b_1;
  // Inline function 'kotlin.collections.set' call
  var value = this.h19_1;
  tmp0.h2(tmp1, value);
}
protoOf(ScopeRegistry).j1d = function (scope) {
  this.e19_1.a19_1.g1d(scope);
  this.g19_1.i2(scope.q1b_1);
};
protoOf(ScopeRegistry).i19 = function () {
  closeAllScopes(this);
  this.g19_1.d2();
  this.f19_1.d2();
};
protoOf(ScopeRegistry).s19 = function (modules) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = modules.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    loadModule_0(this, element);
  }
};
function resolveFromContextOrNull($this, scope, instanceContext, lookupParent) {
  // Inline function 'org.koin.core.resolution.CoreResolver.resolveFromInjectedParameters' call
  var tmp;
  if (instanceContext.j1b_1 == null || instanceContext.j1b_1.p()) {
    tmp = null;
  } else {
    instanceContext.f1b_1.v19('|- ? ' + instanceContext.k1b_1 + ' look in injected parameters');
    tmp = instanceContext.j1b_1.w1c(instanceContext.h1b_1);
  }
  var tmp0_elvis_lhs = tmp;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? resolveFromRegistry($this, scope, instanceContext) : tmp0_elvis_lhs;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'org.koin.core.resolution.CoreResolver.resolveFromStackedParameters' call
    var tmp0_safe_receiver = scope.x1b_1;
    var current = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n18();
    var tmp_1;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (current == null || current.p()) {
      tmp_1 = null;
    } else {
      instanceContext.f1b_1.v19('|- ? ' + instanceContext.k1b_1 + ' look in stack parameters');
      var parameters = current.me();
      tmp_1 = parameters == null ? null : parameters.w1c(instanceContext.h1b_1);
    }
    tmp_0 = tmp_1;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var tmp2_elvis_lhs = tmp_0;
  var tmp_2;
  if (tmp2_elvis_lhs == null) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'org.koin.core.resolution.CoreResolver.resolveFromScopeSource' call
      if (scope.r1b_1 || scope.v1b_1 == null || !(instanceContext.h1b_1.qa(scope.v1b_1) && instanceContext.i1b_1 == null)) {
        tmp$ret$3 = null;
        break $l$block;
      }
      instanceContext.f1b_1.v19('|- ? ' + instanceContext.k1b_1 + ' look at scope source');
      var tmp_3;
      if (instanceContext.h1b_1.qa(scope.v1b_1)) {
        var tmp_4 = scope.v1b_1;
        tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : null;
      } else {
        tmp_3 = null;
      }
      tmp$ret$3 = tmp_3;
    }
    tmp_2 = tmp$ret$3;
  } else {
    tmp_2 = tmp2_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_2;
  var tmp_5;
  if (tmp3_elvis_lhs == null) {
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'org.koin.core.resolution.CoreResolver.resolveFromScopeArchetype' call
      var tmp_6;
      if (scope.r1b_1) {
        tmp_6 = true;
      } else {
        var tmp_7 = scope.p1b_1;
        tmp_6 = !(tmp_7 instanceof TypeQualifier);
      }
      if (tmp_6) {
        tmp$ret$4 = null;
        break $l$block_0;
      }
      instanceContext.f1b_1.v19('|- ? ' + instanceContext.k1b_1 + ' look at scope archetype');
      tmp$ret$4 = $this.k1d_1.a19_1.e1d(instanceContext.i1b_1, instanceContext.h1b_1, instanceContext);
    }
    tmp_5 = tmp$ret$4;
  } else {
    tmp_5 = tmp3_elvis_lhs;
  }
  var tmp4_elvis_lhs = tmp_5;
  var tmp_8;
  if (tmp4_elvis_lhs == null) {
    var tmp_9;
    if (lookupParent) {
      tmp_9 = resolveFromParentScopes($this, scope, instanceContext);
    } else {
      tmp_9 = null == null ? resolveInExtensions($this, scope, instanceContext) : null;
    }
    tmp_8 = tmp_9;
  } else {
    tmp_8 = tmp4_elvis_lhs;
  }
  return tmp_8;
}
function resolveFromContextOrNull$default($this, scope, instanceContext, lookupParent, $super) {
  lookupParent = lookupParent === VOID ? true : lookupParent;
  return resolveFromContextOrNull($this, scope, instanceContext, lookupParent);
}
function resolveFromRegistry($this, scope, ctx) {
  return $this.k1d_1.a19_1.f1d(ctx.i1b_1, ctx.h1b_1, scope.p1b_1, ctx);
}
function resolveFromParentScopes($this, scope, ctx) {
  if (scope.r1b_1)
    return null;
  ctx.f1b_1.v19('|- ? ' + ctx.k1b_1 + ' look in other scopes');
  return findInOtherScope($this, scope, ctx);
}
function findInOtherScope($this, scope, ctx) {
  var parentScope = flatten_0(scope.u1b_1);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
    var _iterator__ex2g4s = parentScope.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      ctx.f1b_1.v19('|- ? ' + ctx.k1b_1 + " look in scope '" + element.q1b_1 + "'");
      var instanceContext = !element.r1b_1 ? ctx.o1b(element) : ctx;
      var result = resolveFromContextOrNull($this, element, instanceContext, false);
      if (!(result == null)) {
        tmp$ret$1 = result;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function resolveInExtensions($this, scope, ctx) {
  var tmp0 = $this.l1d_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      ctx.f1b_1.v19("|- ['" + element.m1d() + "'] ?");
      var tmp = element.n1d(scope, ctx);
      var result = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      if (!(result == null)) {
        tmp$ret$1 = result;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function CoreResolver(_koin) {
  this.k1d_1 = _koin;
  var tmp = this;
  // Inline function 'kotlin.collections.arrayListOf' call
  tmp.l1d_1 = ArrayList_init_$Create$();
}
protoOf(CoreResolver).o1d = function (scope, instanceContext) {
  var tmp0_elvis_lhs = resolveFromContextOrNull$default(this, scope, instanceContext);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp0_safe_receiver = instanceContext.i1b_1;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = " and qualifier '" + toString_0(tmp0_safe_receiver) + "'";
    }
    var tmp1_elvis_lhs = tmp_0;
    var qualifierString = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    throw new NoDefinitionFoundException("No definition found for type '" + getFullName(instanceContext.h1b_1) + "'" + qualifierString + '. Check your Modules configuration and add missing type and/or qualifier!');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
function flatten_0(scopes) {
  // Inline function 'kotlin.collections.linkedSetOf' call
  var flatten = LinkedHashSet_init_$Create$();
  var stack = ArrayDeque_init_$Create$(asReversed(scopes));
  $l$loop_0: while (true) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!!stack.p()) {
      break $l$loop_0;
    }
    var current = stack.re();
    if (!flatten.e(current)) {
      continue $l$loop_0;
    }
    var _iterator__ex2g4s = current.u1b_1.j();
    while (_iterator__ex2g4s.k()) {
      var scope = _iterator__ex2g4s.l();
      if (!flatten.u1(scope)) {
        // Inline function 'kotlin.collections.plusAssign' call
        stack.e(scope);
      }
    }
  }
  return flatten;
}
function resolve($this, clazz, qualifier, parameters) {
  var tmp0 = $this.t1b_1.x18_1;
  // Inline function 'org.koin.core.logger.Logger.isAt' call
  var lvl = Level_DEBUG_getInstance();
  if (!(tmp0.u19_1.m2(lvl) <= 0)) {
    return resolveInstance($this, qualifier, clazz, parameters);
  }
  // Inline function 'org.koin.core.scope.Scope.logInstanceRequest' call
  var tmp;
  if (qualifier == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = " with qualifier '" + toString(qualifier) + "'";
  }
  var tmp1_elvis_lhs = tmp;
  var qualifierString = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  var scopeId = $this.r1b_1 ? '' : " - scope:'" + $this.q1b_1 + "'";
  $this.t1b_1.x18_1.d1a(Level_DEBUG_getInstance(), "|- '" + getFullName(clazz) + "'" + qualifierString + scopeId + '...');
  // Inline function 'kotlin.time.measureTimedValue' call
  // Inline function 'kotlin.time.measureTimedValue' call
  var mark = Monotonic_instance.fd();
  var result = resolveInstance($this, qualifier, clazz, parameters);
  var result_0 = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
  // Inline function 'org.koin.core.scope.Scope.logInstanceDuration' call
  var duration = result_0.il_1;
  $this.t1b_1.x18_1.d1a(Level_DEBUG_getInstance(), "|- '" + getFullName(clazz) + "' in " + get_inMs(duration) + ' ms');
  return result_0.hl_1;
}
function resolveInstance($this, qualifier, clazz, parameters) {
  // Inline function 'org.koin.core.scope.Scope.checkScopeIsOpen' call
  if ($this.y1b_1) {
    throw new ClosedScopeException("Scope '" + $this.q1b_1 + "' is closed");
  }
  var instanceContext = new ResolutionContext($this.t1b_1.x18_1, $this, clazz, qualifier, parameters);
  return stackParametersCall($this, parameters, instanceContext);
}
function stackParametersCall($this, parameters, instanceContext) {
  if (parameters == null) {
    return resolveFromContext($this, instanceContext);
  }
  var tmp0 = $this.t1b_1.x18_1;
  // Inline function 'org.koin.core.logger.Logger.log' call
  var lvl = Level_DEBUG_getInstance();
  // Inline function 'org.koin.core.logger.Logger.isAt' call
  if (tmp0.u19_1.m2(lvl) <= 0) {
    var tmp$ret$1 = '| >> parameters ' + toString(parameters);
    tmp0.d1a(lvl, tmp$ret$1);
  }
  var stack = onParameterOnStack($this, parameters);
  try {
    return resolveFromContext($this, instanceContext);
  }finally {
    $this.t1b_1.x18_1.v19('| << parameters');
    clearParameterStack($this, stack);
  }
}
function onParameterOnStack($this, parameters) {
  var stack = getOrCreateParameterStack($this);
  stack.ne(parameters);
  return stack;
}
function clearParameterStack($this, stack) {
  stack.qe();
  if (stack.p()) {
    var tmp0_safe_receiver = $this.x1b_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c4();
    }
    $this.x1b_1 = null;
  }
}
function getOrCreateParameterStack($this) {
  var tmp0_safe_receiver = $this.x1b_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n18();
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.let' call
    var it = ArrayDeque_init_$Create$_0();
    $this.x1b_1 = new ThreadLocalRef();
    var tmp0_safe_receiver_0 = $this.x1b_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.m18(it);
    }
    tmp = it;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function resolveFromContext($this, instanceContext) {
  return $this.t1b_1.y18_1.o1d($this, instanceContext);
}
function Scope$close$lambda(this$0) {
  return function () {
    this$0.t1b_1.x18_1.v19("|- (-) Scope - id:'" + this$0.q1b_1 + "'");
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this$0.w1b_1.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      element.p1d(this$0);
    }
    this$0.w1b_1.d2();
    this$0.y1b_1 = true;
    this$0.v1b_1 = null;
    var tmp0_safe_receiver = this$0.x1b_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n18();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.d2();
    }
    this$0.x1b_1 = null;
    this$0.t1b_1.z18_1.j1d(this$0);
    return Unit_instance;
  };
}
function Scope(scopeQualifier, id, isRoot, scopeArchetype, _koin) {
  isRoot = isRoot === VOID ? false : isRoot;
  scopeArchetype = scopeArchetype === VOID ? null : scopeArchetype;
  this.p1b_1 = scopeQualifier;
  this.q1b_1 = id;
  this.r1b_1 = isRoot;
  this.s1b_1 = scopeArchetype;
  this.t1b_1 = _koin;
  this.u1b_1 = ArrayList_init_$Create$();
  this.v1b_1 = null;
  this.w1b_1 = LinkedHashSet_init_$Create$();
  this.x1b_1 = null;
  this.y1b_1 = false;
}
protoOf(Scope).q1d = function (clazz, qualifier, parameters) {
  return resolve(this, clazz, qualifier, parameters == null ? null : parameters());
};
protoOf(Scope).a4 = function () {
  var tmp = KoinPlatformTools_instance;
  return tmp.e1c(this, Scope$close$lambda(this));
};
protoOf(Scope).toString = function () {
  return "['" + this.q1b_1 + "']";
};
function get_inMs(_this__u8e3s4) {
  // Inline function 'kotlin.Long.div' call
  return _Duration___get_inWholeMicroseconds__impl__8oe8vv(_this__u8e3s4).j3() / 1000.0;
}
function binds(_this__u8e3s4, classes) {
  var _receiver__tnumb7 = _this__u8e3s4.v1a_1.z1a_1;
  _receiver__tnumb7.o1a_1 = plus(_receiver__tnumb7.o1a_1, classes);
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = classes.length;
  while (inductionVariable < last) {
    var element = classes[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp1 = _this__u8e3s4.v1a_1.z1a_1.l1a_1;
    // Inline function 'org.koin.core.definition.indexKey' call
    var scopeQualifier = _this__u8e3s4.v1a_1.z1a_1.j1a_1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.b8(getFullName(element));
    this_0.c8(_Char___init__impl__6a9atx(58));
    var tmp1_elvis_lhs = tmp1 == null ? null : tmp1.t();
    this_0.b8(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
    this_0.c8(_Char___init__impl__6a9atx(58));
    this_0.a8(scopeQualifier);
    var mapping = this_0.toString();
    _this__u8e3s4.u1a_1.q1c(mapping, _this__u8e3s4.v1a_1);
  }
  return _this__u8e3s4;
}
function module_0(createdAtStart, moduleDeclaration) {
  createdAtStart = createdAtStart === VOID ? false : createdAtStart;
  var module_0 = new Module(createdAtStart);
  moduleDeclaration(module_0);
  return module_0;
}
function get_classNames() {
  _init_properties_KClassExt_kt__5ro5b2();
  return classNames;
}
var classNames;
function getFullName(_this__u8e3s4) {
  _init_properties_KClassExt_kt__5ro5b2();
  var tmp0_elvis_lhs = get_classNames().a2(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? saveCache(_this__u8e3s4) : tmp0_elvis_lhs;
}
function saveCache(_this__u8e3s4) {
  _init_properties_KClassExt_kt__5ro5b2();
  var name = KoinPlatformTools_instance.r1d(_this__u8e3s4);
  // Inline function 'kotlin.collections.set' call
  get_classNames().h2(_this__u8e3s4, name);
  return name;
}
var properties_initialized_KClassExt_kt_dizwhw;
function _init_properties_KClassExt_kt__5ro5b2() {
  if (!properties_initialized_KClassExt_kt_dizwhw) {
    properties_initialized_KClassExt_kt_dizwhw = true;
    classNames = KoinPlatformTools_instance.b1d();
  }
}
function getKClassDefaultName(_this__u8e3s4, kClass) {
  return 'KClass@' + kClass.hashCode();
}
function register($this, koinApplication) {
  if (!($this.s1d_1 == null)) {
    throw new KoinApplicationAlreadyStartedException('A Koin Application has already been started');
  }
  $this.s1d_1 = koinApplication.x19_1;
}
function GlobalContext() {
  this.s1d_1 = null;
}
protoOf(GlobalContext).n18 = function () {
  var tmp0_elvis_lhs = this.s1d_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'KoinApplication has not been started';
    throw IllegalStateException_init_$Create$(toString_0(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(GlobalContext).i1a = function () {
  var tmp0_safe_receiver = this.s1d_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.a4();
  }
  this.s1d_1 = null;
};
protoOf(GlobalContext).h1a = function (appDeclaration) {
  var koinApplication = Companion_instance.z19();
  register(this, koinApplication);
  appDeclaration(koinApplication);
  return koinApplication;
};
var GlobalContext_instance;
function GlobalContext_getInstance() {
  return GlobalContext_instance;
}
function generateId(_this__u8e3s4) {
  return Companion_getInstance().am().toString();
}
function KoinPlatformTools() {
}
protoOf(KoinPlatformTools).m1b = function (e) {
  return e.toString() + toString_0(split(Exception_init_$Create$().toString(), ['\n']));
};
protoOf(KoinPlatformTools).r1d = function (kClass) {
  var tmp0_elvis_lhs = kClass.pa();
  return tmp0_elvis_lhs == null ? getKClassDefaultName(this, kClass) : tmp0_elvis_lhs;
};
protoOf(KoinPlatformTools).t1d = function () {
  return LazyThreadSafetyMode_NONE_getInstance();
};
protoOf(KoinPlatformTools).f1a = function () {
  return GlobalContext_instance;
};
protoOf(KoinPlatformTools).e1c = function (lock, block) {
  return block();
};
protoOf(KoinPlatformTools).b1d = function () {
  return ConcurrentMutableMap_init_$Create$();
};
protoOf(KoinPlatformTools).i1d = function () {
  return ConcurrentMutableSet_init_$Create$();
};
var KoinPlatformTools_instance;
function KoinPlatformTools_getInstance() {
  return KoinPlatformTools_instance;
}
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
GlobalContext_instance = new GlobalContext();
KoinPlatformTools_instance = new KoinPlatformTools();
//endregion
//region block: exports
export {
  Kind_Factory_getInstance as Kind_Factory_getInstance2ge7vb99ubfwr,
  Kind_Singleton_getInstance as Kind_Singleton_getInstance2ue26e37jajuw,
  Companion_getInstance_2 as Companion_getInstance1rlvzabi952im,
  KoinPlatformTools_instance as KoinPlatformTools_instancee23gtnw2c1jl,
  getKoin as getKoin1a1yjjyj0b4v7,
  KoinComponent as KoinComponent2sujxij3104ma,
  KoinScopeComponent as KoinScopeComponent1dts4xrlxjh8s,
  startKoin as startKoin30la02u0gybvw,
  stopKoin as stopKoin2aoov7ygurzl5,
  BeanDefinition as BeanDefinitionhif1nxb54kgk,
  KoinDefinition as KoinDefinition2pr0kscd0vkk6,
  FactoryInstanceFactory as FactoryInstanceFactory2tq2q9e5id3pz,
  SingleInstanceFactory as SingleInstanceFactoryp594z6t2b69a,
  TypeQualifier as TypeQualifier1esmq2h0dalsb,
  named as named1qn5s3wnxjwbv,
  binds as binds4rk2rn2wwzpn,
  module_0 as module39wmcymxxg0fj,
};
//endregion

